import { render, staticRenderFns } from "./PeriodResummaryDialog.vue?vue&type=template&id=0f0aa11b"
import script from "./PeriodResummaryDialog.vue?vue&type=script&lang=js"
export * from "./PeriodResummaryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports